<template>
  <div class="container" id="trs-main">
    <div class="col-md-12" :class="mobileMode && !tabletMode ? 'mobile_app_css' : ''">
      <div class="confirm_mail_background">
        <div class="confirm_mail_frame">
          <div class="detail confirm_mail_detail">
            <div class="wp-head confirm_mail_header">
              <h2>{{TITLE}}</h2>
            </div>
            <div class="wp-content">
              <p style="text-align: center; max-width: 441px; margin: 70px 0 70px 5px; font-size: 18px">
                <span v-if="successPage">{{DEFAULT_SUCCESS_MESSAGE}}</span>
                <span v-if="!successPage">{{errorMessage}}</span>
              </p>
              <p style="margin-bottom: 40px; text-align: center;">
                <a class="btn_login_mypage" :class="mobileMode && !tabletMode ? 'btn_login_mypage_with_mobile' : 'btn_login_mypage_with'"
                   :href="MY_PAGE_LINK">{{TITLE_BUTTON_GO_BACK_MY_PAGE}}</a>
              </p>

              <div class="mobile-nav" v-if="mobileMode && !tabletMode && launchOpenAppDirective">
                <a style="margin: 10px 0 10px 0;" class="btn btn-lg-edit btn-block btn-danger"
                   v-open-app-mobile
                   :url-app-store="links.FX_APPSTORE_URL"
                   :url-universal-link="links.FX_UNIVERSAL_LINK_URL"
                   :url-deep-link="links.FX_DEEP_LINK_URL"
                   :url-android-link="links.FX_OPENAPP_ANDROID_URL" href="#">
                  {{$t("trs.front.header.label.fx.trade.app")}}
                </a>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery';
import Config from '../../services/Config';

export default {
    data() {
        return {
            SERVICE_NAME: "profile",
            TITLE: null,
            DEFAULT_SUCCESS_MESSAGE: null,
            MY_PAGE_LINK: null,
            TITLE_BUTTON_GO_BACK_MY_PAGE: null,
            successPage: false,
            errorMessage: null,
            links: {},
            launchOpenAppDirective : false
        }
    },
    created() {
        const token = this.$route.query.token;
        if (token) {
            this.$service.getService(this.SERVICE_NAME).confirmMail(token).then((res) => {
                if (res) {
                    this.successPage = !res.errorMessage;
                    this.errorMessage = res.errorMessage;
                    this.initLinks(res);
                }
            })
        } else {
            this.$router.push({name: "home"})
        }
    },
    mounted() {
        this.TITLE = this.IConstants.CONFIRM_MAIL.TITLE;
        this.DEFAULT_SUCCESS_MESSAGE = this.IConstants.CONFIRM_MAIL.DEFAULT_SUCCESS_MESSAGE;
        this.MY_PAGE_LINK = Config.getDomain();
        this.TITLE_BUTTON_GO_BACK_MY_PAGE = this.IConstants.CONFIRM_MAIL.TITLE_BUTTON_GO_BACK_MY_PAGE;
        $("body").addClass(this.mobileMode && !this.tabletMode ? "mobile_app_css_body" : "");
    },
    methods: {
        initLinks(res) {
            this.links.FX_APPSTORE_URL = res.fxAppStoreUrl;
            this.links.FX_UNIVERSAL_LINK_URL = res.fxUniversalLinkUrl;
            this.links.FX_DEEP_LINK_URL = res.fxDeepLinkUrl;
            this.links.FX_OPENAPP_ANDROID_URL = res.fxOpenAppAndroidUrl;
            // only launch "open-app-mobile" directive when "links" has data
            this.launchOpenAppDirective = true;
        }
    }
}
</script>
